import * as React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import { API } from "aws-amplify";
import ErrorResponse from "./ErrorResponse";

interface IProps {
  personId?: string;
}

interface IState {
  customerPaymentPreferences: any[];
  exception: boolean;
  giftCard: boolean;
  hsaCard: boolean;
  message: string;
  paymentMethod?: string;
  paymentMethodId: string;
}

class PaymentSection extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      customerPaymentPreferences: [],
      exception: false,
      giftCard: false,
      hsaCard: false,
      message: "",
      paymentMethod: undefined,
      paymentMethodId: "",
    };

    this.handlePayment = this.handlePayment.bind(this);
    this.handleGiftCard = this.handleGiftCard.bind(this);
    this.handleHSACard = this.handleHSACard.bind(this);
  }

  public render() {
    const showLoadingSpinner =
      this.state.customerPaymentPreferences.length === 0;
    if (!showLoadingSpinner && this.state.paymentMethodId.length === 0) {
      for (const customerPaymentPreference of this.state
        .customerPaymentPreferences) {
        this.setState({ paymentMethodId: customerPaymentPreference.id });
        break;
      }
    }

    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          {showLoadingSpinner && !this.state.exception && <LoadingSpinner />}

          {!showLoadingSpinner && !this.state.exception && (
            <Grid item xs>
              <FormControl>
                <InputLabel>Payments (Required)</InputLabel>
                <Select
                  value={this.state.paymentMethodId}
                  style={{ width: 225 }}
                  onChange={this.handlePayment}
                >
                  // @ts-ignore
                  {this.state.customerPaymentPreferences.map(
                    (customerPaymentPreference) => (
                      <MenuItem value={customerPaymentPreference.id}>
                        <em>{customerPaymentPreference.paymentMethod}</em>
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}

          {!showLoadingSpinner && !this.state.exception && (
            <Grid item xs>
              <FormControl component="fieldset">
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={<Checkbox checked={this.state.giftCard} />}
                    label="Use Gift Card ... will error out if customer doesn't have a valid gift card."
                    onChange={this.handleGiftCard}
                  />
                </FormGroup>
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={<Checkbox checked={this.state.hsaCard} />}
                    label="Use HSA Card ... will error out if customer doesn't have a valid HSA card."
                    onChange={this.handleHSACard}
                  />
                </FormGroup>
              </FormControl>
            </Grid>
          )}

          {this.state.message && (
            <ErrorResponse
              message={this.state.message}
              dialogTitle={"Payment Response Exception"}
            />
          )}
        </Grid>
      </Grid>
    );
  }

  public componentDidMount() {
    this.getPayments();
  }

  // PaymentMethodId is overloaded:
  // * Paying with insurance: the UI loads in the payerId, and Portal uses it to filter the insurance payers
  // correctly, and the payment method defaults to Credit Card (through the Customer Payment Preferences default).
  //
  // * Paying with a selected credit card: the UI loads the credit card's Amazon WalletId into PaymentMethodId.
  //
  // * Paying with a gift card: since the UI can't see all of a customer's the payment methods, the Gift Card checkbox
  // clears the PaymentMethodId and sets the PaymentMethod to GiftCard, which Portal's OrderService handles
  // by selecting the first Gift Card returned by the Pay Station service.  (same with HSA Card)
  //
  // * Empty: Portal's OrderService defaults to the deciders, depending on the OrderType value:
  // (cash | primeRx | rxpass) ... any value not in this set defaults to the Lowest Price Decider
  public handlePayment(event: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({ paymentMethodId: event.target.value });
  }

  public handleGiftCard(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) {
      this.setState({ giftCard: event.target.checked });
      this.setState({ paymentMethod: "giftCard" });
    } else {
      this.setState({ giftCard: event.target.checked });
      this.setState({ paymentMethod: undefined });
    }
  }

  public handleHSACard(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) {
      this.setState({ hsaCard: event.target.checked });
      this.setState({ paymentMethod: "hsaCard" });
    } else {
      this.setState({ hsaCard: event.target.checked });
      this.setState({ paymentMethod: undefined });
    }
  }

  public getState() {
    return this.state;
  }

  private getPayments() {
    const apiName = "ApaqPortalAPI";
    const path =
      "/customer/payment/get-payment-preferences?personId=" +
      this.props.personId;
    API.get(apiName, path, {})
      .then((value: any) => {
        const result = [];
        for (const entry of value.customerPaymentPreferences) {
          result.push(entry);
        }

        this.setState({ customerPaymentPreferences: result });

        if (result.length === 0) {
          this.setState({
            message: "No payment method found on customer account.",
          });
          this.setState({ exception: true });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ message: error.response.data.message });
        this.setState({ exception: true });
      });
  }
}

export default PaymentSection;
